// extracted by mini-css-extract-plugin
export default {"back__button__wrapper":"buttons_back__button__wrapper__FZzlV","load__more__button":"buttons_load__more__button__2s3ng"};